//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as b from '@/static/blog.json'

let blog = b.default

export default {
	data() {
		return {
			categoria: '',
			imageLoaded: false,
			blog,
		}
	},
	computed: {
		categoriasBlog() {
			let categorias = this.blog.map((n) => n.categoria).flat()
			let flated = [...new Set(categorias.map((c) => c.nome))]
			let final = []
			flated.forEach((element) => {
				categorias.find((c) => {
					if (
						c.nome === element &&
						!final.map((m) => m.nome).includes(element)
					) {
						final.push(c)
					}
				})
			})
			return final
		},
	},
}
